export const URL_WEB_SERVICE_LOCAL_STORAGE = localStorage.getItem('url_detalle_default') ? localStorage.getItem('url_detalle_default') : "";
